import { useShop, useI18n } from "@/context/Shop";
import { LANGS } from "@/lib/i18n";

const seg = (active, dark) => `px-1.5 py-0.5 transition-colors ${active ? (dark ? "text-white font-semibold" : "text-foreground font-semibold") : dark ? "text-[hsl(var(--header-muted))] hover:text-white" : "text-muted-foreground hover:text-foreground"}`;

/** EN / SQ switch. `dark` renders for black surfaces (header, footer). */
export function LanguageToggle({ dark = true, className = "" }) {
  const { lang, setLang } = useShop();
  const { t } = useI18n();
  return (
    <div className={`inline-flex items-center text-[11px] uppercase tracking-[0.14em] ${className}`} role="group" aria-label={t("language")} data-testid="language-toggle">
      {LANGS.map((l, i) => (
        <span key={l} className="inline-flex items-center">
          {i > 0 && <span className={dark ? "text-white/30" : "text-border"}>|</span>}
          <button type="button" onClick={() => setLang(l)} aria-pressed={lang === l} className={seg(lang === l, dark)} data-testid={`language-${l}-button`}>{l.toUpperCase()}</button>
        </span>
      ))}
    </div>
  );
}

/** ALL / EUR display switch. Checkout is always in ALL; EUR is a reference. */
export function CurrencyToggle({ dark = true, className = "" }) {
  const { currencyMode, setCurrencyMode, config } = useShop();
  const { t } = useI18n();
  const fx = config?.fx?.EUR;
  return (
    <div className={`inline-flex items-center text-[11px] uppercase tracking-[0.14em] ${className}`} role="group" aria-label={t("currency")} title={fx ? `1 EUR = ${fx} ALL` : undefined} data-testid="currency-toggle">
      {["ALL", "EUR"].map((c, i) => (
        <span key={c} className="inline-flex items-center">
          {i > 0 && <span className={dark ? "text-white/30" : "text-border"}>|</span>}
          <button type="button" onClick={() => setCurrencyMode(c)} aria-pressed={currencyMode === c} className={seg(currencyMode === c, dark)} data-testid={`currency-${c.toLowerCase()}-button`}>{c === "ALL" ? "ALL L" : "EUR €"}</button>
        </span>
      ))}
    </div>
  );
}
